import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"
import { toast } from "sonner"

export default function useCancelSubscription() {
  return useMutation({
    mutationFn: (userId: string) => api.admin.cancelSubscription(userId),
    onSuccess: () => {
      toast.success("Suscripción cancelada correctamente")
    },
    onError: () => {
      toast.error("Error al cancelar la suscripción")
    },
  })
}
